<!-- container-xxl -->
<style>
.innovative_projects_design{background: #00a2e2;
    color: #ffffff;
    padding: 20px;
    font-size: 20px;
    border-radius: 8px; display: block;}
.innovative_projects_design i{background: white;
    padding: 10px 20px;
    font-size: 30px;
    border-radius: 50%; color: #00a2e2;}
</style>
<div class="content-wrapper aboutus-content-wrapper-container p-0 content-aboutus-outer-container">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <!-- <div class="content-body content-body-outer-img-container">
      <img src="assets\images\about-us-img\Group 158.png" alt="about-us">
    </div> -->
    <div class="content-body">
      <!-- app e-commerce details start -->
    
        <div class="container">
            <!-- <div class="row">
                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a href="{{documentURL}}/pdf/NALSUN-Innovative-Coating-Technology-for-Solar-water-Heaters.pdf" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i>  NALSUN-NG (Solar Water Heaters)</a>
                </div>

                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a href="{{documentURL}}/pdf/Nanocoating-for-Solar-Panels-TriNano-Technologies.pdf" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Eco-friendly Tri-NANO Coating Technology (Solar Panel efficiency)</a>
                </div>

                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a target="_blank" href="https://twitter.com/csirnalofficial?lang=en" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Industry Transfer of NALSUN-Next Generation Solar Thermal Coating;<br>[14 February 2024]</a>
                </div>

               
            </div> -->
            <!-- <div class="row">
                <div class="col-xl-12 " >
                    <div class="row" style="padding: 15px;">
                        <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;
                border: 1px solid #dedede;
                border-radius: 8px;">
                    <a target="_blank" href="https://twitter.com/csirnalofficial?lang=en" target="_blank"  class=""> <i class="fa fa-check-circle-o" style="font-size: 40px;
                        float: left;
                        margin-right: 15px;"></i> Industry Transfer of NALSUN-Next Generation Solar Thermal Coating; <i>[14 February 2024]</i></a>
                </div>
                    </div>
                </div>
            </div> -->

            <div class="table-responsive table-bordered">
				<table class="table mb-0 table-striped table-bordered">
					<thead>
						<tr>
							<th>S.No</th>
							<th>Innovation</th>
							<th>Technology Brief</th>
							<th>Benefit</th>
							<th>Thematic Area</th>
                            <th>Focal Point</th>
                            <th>Status</th>
						</tr>
					</thead>
					<tbody>
						<tr>
							<td style="text-align: center;">1</td>
							<td scope="col" class="text-wrap">NALSUN Coating
                                [Next Generation Solar Thermal Coating]</td>
							<td scope="col" class="text-wrap">NALSUN Technology Brief <u><a href="{{documentURL}}/pdf/NALSUN-Innovative-Coating-Technology-for-Solar-water-Heaters.pdf" target="_blank">Click Here</a></u><br> For Product video <u><a href="https://www.nal.res.in/en/technology/nalsun-ng" target="_blank">Click Here</a></u></td>
							<td scope="col" class="text-wrap">Indigenously developed, Graphene-based, cost-effective Solar Thermal Coating Technology</td>
							<td scope="col" class="text-wrap">Solar Thermal</td>
                            <td scope="col" class="text-wrap">
								CSIR – National Aerospace Laboratory (NAL)
							</td>
                            <td scope="col" class="text-wrap">
								Industry Transfer of CSIR-NAL's NALSUN-Next Generation Solar Thermal Coating to M/s Supreme Solar Projects for Manufacturing and Commercialization on 14th February 2024 <u><a target="_blank" href="https://twitter.com/csirnalofficial?lang=en" target="_blank"  class="">Click Here</a></u>
							</td>
						</tr>
						<tr>
							<td style="text-align: center;">2</td>
							<td scope="col" class="text-wrap">Eco-friendly Tri-NANO Coating Technology</td>
							<td scope="col" class="text-wrap">TriNANO Coating Technology Click <u><a href="{{documentURL}}/pdf/Nanocoating-for-Solar-Panels-TriNano-Technologies.pdf" target="_blank">Click Here</a></u></td>
                            <td scope="col" class="text-wrap">Improved Solar Panel Output (7%-8%)</td>
							<td scope="col" class="text-wrap">Solar PV</td>
							<td>TriNANO Technologies Pvt. Ltd</td>
                            <td>Tested at NISE and NCPRE</td>
						</tr>
					</tbody>
				</table>
			</div><br />

            <!-- <div class="row">
                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a href="http://10.247.7.136/geothermal-energy" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Geothermal Energy</a>
                </div>

                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a href="http://10.247.7.136/ocean-energy" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Ocean Energy</a>
                </div>

                <div class="col-xl-4 col-md-6 col-12 " style="padding: 15px;">
                    <a target="_blank" href="https://twitter.com/csirnalofficial?lang=en" target="_blank"  class="innovative_projects_design"> <i class="fa-solid fa-caret-right"></i> Industry Transfer of NALSUN-Next Generation Solar Thermal Coating;<br>[14 February 2024]</a>
                </div>

               
            </div> -->

        </div>
    </div>
  </div>